import {Octicon, Tooltip} from '@primer/react/deprecated'
import {MeterIcon, SkipIcon, PlayIcon, NoEntryIcon} from '@primer/octicons-react'
import {RulesetEnforcement} from '../types/rules-types'
import {enforcementLabelText} from '../helpers/enforcement-label'
import styles from './EnforcementIcon.module.css'
import {useUpsellInfoContext} from '../contexts/UpsellInfoContext'

export function EnforcementIcon({hideText, enforcement}: {hideText?: boolean; enforcement: RulesetEnforcement}) {
  let text = ''
  let icon: React.ReactElement | null = null
  const upsellInfo = useUpsellInfoContext()

  if (
    upsellInfo &&
    ((!upsellInfo.rulesets.featureEnabled && enforcement !== RulesetEnforcement.Disabled) ||
      (!upsellInfo.enterpriseRulesets.featureEnabled && enforcement === RulesetEnforcement.Evaluate))
  ) {
    text = 'Not enforced'
    icon = <Octicon icon={NoEntryIcon} className={styles.EnforcementIconOcticonAttention} aria-label="Not enforced" />
  } else {
    text = enforcementLabelText(enforcement)
    switch (enforcement) {
      case RulesetEnforcement.Enabled:
        icon = <Octicon icon={PlayIcon} className={styles.EnforcementIconOcticonSuccess} aria-label={text} />
        break
      case RulesetEnforcement.Evaluate:
        icon = <Octicon icon={MeterIcon} className={styles.EnforcementIconOcticonSevere} aria-label={text} />
        break
      default:
        icon = <Octicon icon={SkipIcon} className={styles.EnforcementIconOcticonMuted} aria-label={text} />
        break
    }
  }

  return hideText ? (
    <Tooltip text={text}>{icon}</Tooltip>
  ) : (
    <div className={styles.EnforcementIconContainer}>
      {icon}
      <span className={styles.EnforcementIconText}>{text}</span>
    </div>
  )
}

try{ EnforcementIcon.displayName ||= 'EnforcementIcon' } catch {}